import React, { useState } from 'react';
import { reportIssue, cancelCheckin } from '_services/remote-checkin-service';

const OPTIONS = [
    { value: 'not_collected', label: "I wasn't collected" },
    { value: 'no_longer_needed', label: 'I no longer need assistance' },
    { value: 'other', label: 'Something else' },
];

const ReportIssueModal = ({ onClose, onCancelled }) => {
    const [selected, setSelected] = useState(null);
    const [note, setNote] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    const handleSubmit = async () => {
        if (!selected) return;
        setSubmitting(true);
        setError('');
        try {
            if (selected === 'no_longer_needed') {
                await cancelCheckin();
                onCancelled();
                return;
            }
            await reportIssue(selected, note.trim() || null);
            setDone(true);
        } catch (e) {
            if (e.message?.includes('Report limit reached')) {
                setError('You have already submitted the maximum number of reports for this check-in.');
            } else {
                setError("We couldn't submit your report. Please try again.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="rc-modal-backdrop" role="dialog" aria-modal="true" aria-label="Report an issue">
            <div className="rc-modal" onClick={e => e.stopPropagation()}>
                {done ? (
                    <>
                        <p className="rc-modal-title">Report received</p>
                        <p style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                            A controller has been notified and will review your request.
                        </p>
                        <button className="rc-btn-primary" onClick={onClose}>Close</button>
                    </>
                ) : (
                    <>
                        <button
                            className="rc-popover-close"
                            style={{ float: 'right' }}
                            onClick={onClose}
                            aria-label="Close"
                        >
                            ✕
                        </button>
                        <p className="rc-modal-title">Report an issue</p>
                        <p className="rc-modal-subtitle">What would you like to report?</p>

                        {OPTIONS.map(opt => (
                            <button
                                key={opt.value}
                                type="button"
                                className={`rc-option-btn${selected === opt.value ? ' selected' : ''}`}
                                onClick={() => setSelected(opt.value)}
                            >
                                {opt.label}
                            </button>
                        ))}

                        {selected === 'other' && (
                            <div>
                                <textarea
                                    className="rc-textarea"
                                    placeholder="Describe your issue (optional)"
                                    value={note}
                                    onChange={e => setNote(e.target.value.slice(0, 500))}
                                    aria-label="Additional details"
                                />
                                <p className="rc-char-count">{note.length}/500</p>
                            </div>
                        )}

                        {error && <div className="rc-error" role="alert">{error}</div>}

                        <button
                            type="button"
                            className="rc-btn-primary"
                            style={{ marginTop: 16 }}
                            disabled={!selected || submitting}
                            onClick={handleSubmit}
                            aria-busy={submitting}
                        >
                            {submitting ? 'Submitting…' : 'Submit'}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ReportIssueModal;
